<template>
    <div class="wrapFczs">
        <!--标题-->
        <div class="headerF">
            教育类型：
            <span
                :class="[{ chooseColor: isColor[index] }, headerSpanF]"
                v-for="(val, index) in arrOne"
                :key="index"
                @click="
                    changeType(val.type, val.id),
                        change(index),
                        changeZxkc(),
                        changeColor(index)
                "
                >{{ val.coursesType }}</span
            >
            <div class="twoHeader">
				<span v-show="arrTwo && arrTwo.length!=0">课程分类：</span>
                <span
                    v-show="arrTwo"
                    :class="[{ changeColorTwo: isColor2[index1] }, twoSpanF]"
                    v-for="(val1, index1) in arrTwo"
                    :key="index1"
                    @click="
                        changeType(val1.type, val1.id),
                            changeZxkc(),
                            chooseColorTwo(index1)
                    "
                    >{{ val1.coursesType }}</span
                >
            </div>
        </div>

        <!--内容-->
        <div class="contentF">
            <div
                class="boxF"
                v-for="(val, index) in arrThree"
                :key="index"
                @click="goDetails(val)"
            >
                <div class="imgF scale-box">
                    <img :src="val.cover" :alt="val.totalTitle" />
                </div>
                <div class="titleF">{{ val.totalTitle }}</div>
                <div class="timeF">
                    {{ val.creaTime.time | dateFormat }}
                    <span class="viewF">浏览量:{{ val.popularity }}</span>
                </div>
            </div>
        </div>
        <pagebreak :totalPage="totalPage" @changePage="changePage"></pagebreak>
    </div>
</template>
<script type="text/javascript">
export default {
    name: "zxkc",
    data() {
        return {
            arrOne: [],
            arrTwo: [],
            arrThree: [],
            isColor: [], //一级分类
            headerSpanF: "headerSpanF",
            isColor2: [], //二级分类
            twoSpanF: "twoSpanF",
            totalPage: 1,
            courseTypeOne: null,
            courseTypeTwo: null,
            page: 1
        };
    },
    created() {},
    methods: {
        change(index) {
            this.arrTwo = null;
            if (this.arrOne[index].subList) {
                this.arrTwo = this.arrOne[index].subList;
                for (var i = 0; i < this.arrTwo.length; i++) {
                    this.isColor2[i] = 0;
                }
            }
        },
        //课程详情
        goDetails(val) {
            this.$router.push({
                name: "classDetails",
                query: { id: val.id, t1: "在线课程" }
            });
        },
        //切换页码
        changePage(index) {
            this.page = index;
            this.changeZxkc();
        },
        //切换分类
        changeType(type, id) {
			// console.log(type,id);
            this.page = 1;
            (this.courseTypeOne = null), (this.courseTypeTwo = null);
            if (type == 1) {
                this.courseTypeOne = id;
                // alert(id);
            } else if (type == 2) {
                this.courseTypeTwo = id;
            }
        },
        changeColor(index) {
			// console.log(index);
            for (var i = 0; i < this.isColor.length; i++) {
                this.isColor[i] = 0;
            }
            this.isColor[index] = 1;
        },
        chooseColorTwo(index) {
            for (var i = 0; i < this.arrTwo.length; i++) {
                this.isColor2[i] = 0;
            }
            this.isColor2[index] = 1;
        },
        change1() {
            this.arrTwo = [];
        },
        changeZxkc() {
            //在线课程
            let data = {
                courseTypeOne: this.courseTypeOne,
                courseTypeTwo: this.courseTypeTwo,
                current: this.page,

            };
            this.$ajax({
                method: "post",
                url: "homePage/getCoursesSeries",
                data: data,
                success: res => {
                    this.totalPage = Math.ceil(
                        res.message.total / res.message.size
                    );
                    this.arrThree = res.message.records;
                },
                error: res => {}
            });
        }
    },
    created() {
      
		if(this.$route.query.classify==1){
			  //在线课程 类型
			this.$ajax({
			    method: "post",
			    url: "homePage/getCoursesType",
			    success: res => {
			        this.arrOne = res.message;
			        this.arrOne.unshift({
			            coursesType: "全部"
			        });
			        for (var i = 0; i < this.arrOne.length; i++) {
			            if (i == 4) {
			                this.isColor[i] = 1;
							// this.arrTwo = this.arrOne[1].subList;
							// this.isColor2[0] = 1;
							 this.$ajax({
							    method: "post",
							    url: "homePage/getCoursesSeries",
							    data: {
									courseTypeOne: 99,
									current: 1
								},
							    success: res => {
							        this.totalPage = Math.ceil(
							            res.message.total / res.message.size
							        );
							        this.arrThree = res.message.records;
							    },
							    error: res => {}
							});
			            } else {
			                this.isColor[i] = 0;
			            }
			        }
			    },
			    error: res => {}
			});

		}else if(this.$route.query.classify==2){
						  //在线课程 类型
			this.$ajax({
			    method: "post",
			    url: "homePage/getCoursesType",
			    success: res => {
			        this.arrOne = res.message;
			        this.arrOne.unshift({
			            coursesType: "全部"
			        });
			        for (var i = 0; i < this.arrOne.length; i++) {
			            if (i == 3) {
			                this.isColor[i] = 1;
							// this.arrTwo = this.arrOne[1].subList;
							// this.isColor2[0] = 1;
							 this.$ajax({
							    method: "post",
							    url: "homePage/getCoursesSeries",
							    data: {
									courseTypeOne: 99,
									current: 1
								},
							    success: res => {
							        this.totalPage = Math.ceil(
							            res.message.total / res.message.size
							        );
							        this.arrThree = res.message.records;
							    },
							    error: res => {}
							});
			            } else {
			                this.isColor[i] = 0;
			            }
			        }
			    },
			    error: res => {}
			});
		}else{
			  //在线课程 类型
			this.$ajax({
			    method: "post",
			    url: "homePage/getCoursesType",
			    success: res => {
			        this.arrOne = res.message;
			        this.arrOne.unshift({
			            coursesType: "全部"
			        });
			        for (var i = 0; i < this.arrOne.length; i++) {
			            if (i == 0) {
			                this.isColor[i] = 1;
			            } else {
			                this.isColor[i] = 0;
			            }
			        }
			    },
			    error: res => {}
			});
			this.changeZxkc();
		}
    }
};
</script>
<style scoped="scoped">
.twoHeader {
    /* margin-top: 20px; */
	/* margin-left: 55px; */
}

.twoSpanF {
	display: inline-block;
    margin-right: 30px;
	margin-top: 20px;
    font-size: 16px;
    /* color: gray; */
    cursor: pointer;
}

.changeColorTwo {
	display: inline-block;
    margin-right: 30px;
	margin-top: 20px;
    font-size: 16px;
    color: #6ac0e8;
    cursor: pointer;
}
.wrapFczs {
    width: 1000px;
    overflow: hidden;
    margin: 30px auto;
    min-height: 500px;
}

.contentF {
    width: 1000px;
    min-height: 500px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
    cursor: default;
}

.headerSpanF {
    margin-right: 30px;
    cursor: pointer;
}

.boxF {
    width: 242px;
    display: inline-block;
    margin-top: 20px;
    margin-right: 10px;
    box-sizing: border-box;
}
.boxF:nth-child(4n) {
    margin-right: 0;
}

.imgF {
    width: 100%;
    height: 164.9px;
    border: 1px solid #ddd;
    box-sizing: border-box;
    overflow: hidden;
    cursor: pointer;
}
.imgF img {
    width: 100%;
    min-height: 100%;
    transition: all ease 0.2s;
}

.imgF:hover {
    border: 1px solid #999;
}

.titleF {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.timeF {
    color: gray;
    font-size: 14px;
    padding: 0 5px 0 0;
}

.viewF {
    float: right;
}

.chooseColor{
    color: #6ac0e8;
}
</style>



// WEBPACK FOOTER //
// src/components/zxkc/zxkc.vue